export class AppInfo {
  static version(): string {
    return process.env.NEXT_PUBLIC_BUILD_VERSION ?? "unknown";
  }
}
